import { Grid, Typography, Card, Button} from '@mui/material'
import { ReactComponent as LockIcon} from '../../../icons/lockIcon.svg';
import { ReactComponent as Lock} from '../../../icons/lock.svg';
import React from 'react'
import colors from '../../colors';
import { useNavigate } from 'react-router-dom';
import { texts } from '../../general/texts';

export const Security = () => {

    const navigate = useNavigate()

  return (
    <Grid container justifyContent={'center'} pt={'3%'} >
        <Card  sx={{width:'50%',boxShadow:'0 0 15px 5px #E5E7EA', borderRadius:'20px', '@media (max-width: 899px)' : {width:'90%'}}} >
            <Grid container rowSpacing={7} pt={'3%'} pb={'8%'} >
            <Grid container item md={12} xs={12} >
                <Grid container  direction="column" justifyContent="center" alignItems="center" sx={{backgroundColor: colors.cyan,borderRadius:'20px',width:'60px',height:'60px',marginLeft:'3%'}}>
                    <LockIcon />
                </Grid>
                <Typography sx={{color: colors.darkBlue, fontSize:'1.5rem', fontFamily:'GerberaBold',paddingTop:'1%',paddingLeft:'2%'}} >{texts["placeholder-security"]}</Typography>
                
                {/* <Grid container item md={2} xs={5} alignItems={'right'} ><Button sx={{mt:'3%', height:'2rem', fontSize:'0.6rem', color:colors.darkBlue, border:'1px solid', borderColor:colors.darkBlue, borderRadius:'10px'}} >Ndrysho të dhënat</Button></Grid> */}
            </Grid>
                {/* <Grid container item rowSpacing={2} >
                <Grid container item md={1} xs={2} justifyContent={'center'}  ml={'2%'}  ><Box sx={{background:colors.cyan, borderRadius:'15px', width:'70%', height:'100%', pt:'13%'}} ><LockIcon  /></Box></Grid>
                    <Grid item md={10} xs={8} sx={{textAlign:'left', mt:'1%'}} ><Typography sx={{color:colors.darkBlue, fontSize:'1.5rem',fontFamily:'GerberaBold'}} >Siguria</Typography></Grid>
                </Grid> */}
                <Grid container item rowSpacing={5} pl={'3%'} >
                    <Grid container justifyContent={'center'} sx={{mt:'10%', pb:'10%'}}  >
                        <Card elevation={0} sx={{backgroundColor:colors.cyan, width:'50%', borderRadius:'20px',  '@media (max-width: 899px)' : {width:'90%'}}} >
                            <Button onClick={()=> { navigate('/forgotPassword') }} sx={{":hover":{backgroundColor:colors.lightGray}, width:'100%', height:"100%",paddingBottom:'7%'}} >
                                <Grid item container md={12} xs={12} >
                                    <Grid item md={3} xs={4} sx={{pt:'8%'}} >
                                        <Lock />
                                    </Grid>
                                    <Grid item md={9} xs={8} sx={{paddingTop:'12%', pl:'8%'}}>
                                        <Typography  sx={{color:colors.darkBlue, fontFamily:'GerberaLight', textTransform:'none'}} textAlign='left' >{texts["button-change-password"]}</Typography>
                                    </Grid>
                                </Grid>
                            </Button>
                        </Card>
                    </Grid>
                </Grid>
            </Grid>
        </Card>
    </Grid>
  )
}

export default Security